import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Event as NavigationEvent, NavigationStart, Router } from '@angular/router';
import { AccountAdminRole, RoleManagement } from '@configs/role.config';
import { ConfigService } from '@services/config.service';
import { RoleManagementService } from '@services/role.management.service';
import { Subscription } from 'rxjs';
import { filter } from "rxjs/operators";
import { AppService } from '../services/app.service';
import { CollectionService } from '../services/collection.service';
import { ReportsService } from '../services/reports.service';
import { ShareDataService } from '../services/share-data.service';
import { WebErrorService } from '@services/webError.service';
import { IdleService } from '../shared/idle.service';
import { UserService } from '@services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AssessmentService } from '@services/assessment.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  isExpanded = true;
  isShowing = false;
  status = false;
  show = false;
  collectionData$: Subscription | undefined;
  ExpireTokenSubscription: Subscription;
  collectionData: any;
  selectedCollectionName = "TEJ";
  userDetails: any = {
    parentId: 0,
    userId: 0,
    roleDetails: {
      id: 0,
      name: '',
      description: '',
      privileges: []
    },
    userName: ''
  };
  firstName: string;
  lastName: string;
  collectionIdToNavigate: string;
  collectionuuIdToNavigate: any;
  tagUrl = "/collections/";
  emailId: any;
  searchOptions = [];
  filteredList: any;
  selected: any;
  selectedCollection;
  collectionID: number;
  roles: any;
  secondaryColorPalette: any[] = [];
  collectionFlag: Object = false;
  rolesFlag: boolean = false;
  accountAdmin = AccountAdminRole.accountAdmin;
  roleRights: any;
  Items: boolean = false;
  Reports: boolean = false;
  Tests: boolean = false;
  Examinees: boolean = false;
  Tags: boolean = false;
  Users: boolean = false;
  rolesData: any;
  browserLang: string;
  languageData = [];
  languageSubsc: Subscription;
  selecter: any;
  assignedRole: any;
  Home: boolean = false;
  Assessments: boolean = false;
  constructor(private reportService: ReportsService,
    private router: Router, private appService: AppService,
    private collectionService: CollectionService,
    private shareDataService: ShareDataService,
    private webErrorService: WebErrorService,
    public roleSer: RoleManagementService,
    public configService: ConfigService,
    private idleService: IdleService,
    private userService: UserService,
    public dialog: MatDialog,
    public AssessmentSer: AssessmentService,
    public translate: TranslateService,) {
    router.events
      .pipe(
        filter(
          (event: NavigationEvent) => {
            return (event instanceof NavigationStart);
          }
        )
      )
      .subscribe(
        (event: NavigationStart) => {
          if (event.restoredState) {
            console.warn("restoring navigation id:", event.restoredState.navigationId);
          }
          console.groupEnd();
        }
      )
      ;
  }

  mouseenter(): void {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
  }

  mouseleave(): void {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }

  ngOnInit(): void {
    if ((JSON.parse(sessionStorage.getItem('currentUser') || '{}').firstName) || (JSON.parse(sessionStorage.getItem('currentUser') || '{}').firstName)) {
      this.firstName = JSON.parse(sessionStorage.getItem('currentUser') || '{}').firstName;
      this.lastName = JSON.parse(sessionStorage.getItem('currentUser') || '{}').lastName;
      this.emailId = JSON.parse(sessionStorage.getItem('currentUser') || '{}').emailId;
      this.assignedRole = JSON.parse(sessionStorage.getItem('currentUser') || '{}').userRolesCollections[0].rolesAssigned;
    } else {
      this.firstName = '';
      this.lastName = ''
    }

    this.shareDataService.collectionData.subscribe(data => {
      this.selectedCollectionName = data?.collectionName;
    });

    this.collectionService.getNewCollectionData.subscribe(data => {
      this.loadCollections();
    });

    this.shareDataService.globalCollectionuuId$.subscribe(glCollectionUUID => {
      this.collectionuuIdToNavigate = glCollectionUUID;
    });

    this.loadCollections();
    this.getUserRole(this.collectionID);

    this.processIdle();

    // -------Set Localisation------------
    const langId = localStorage.getItem("langId");
    const langCode = localStorage.getItem("language");

    if (langId && !langCode) {
      // console.log('I have id but not code');
      this.languageSubsc = this.userService.getLanguage().subscribe(data=> {
        this.languageData = data.items;
        const matchData = this.languageData.filter(el => el.langId == langId);
        if (matchData.length > 0) {
          this.translate.use(matchData[0].languagecode)
        }
      })
    } else if (langId && langCode) {
      // console.log('I have id and code');
      this.translate.use(langCode);
    }

    this.appService.selectedCollectionName.subscribe(data => {
      if (data) {
        this.loadCollections();
      }
    })
  }

  getUserRole(collectionID) {
    this.Items = false;
    this.Reports = false;
    this.Tests = false;
    this.Examinees = false;
    this.Tags = false;
    this.Users = false;
    this.collectionFlag = false;
    this.rolesFlag = false;
    this.Assessments = false;
    this.Home = false;

    this.roleSer.getUserRole(collectionID).subscribe(data => {
      this.roles = data.data?.userrole;

      data.data?.userrole.forEach(element => {
        if (element.featureName == RoleManagement.Items) { this.Items = element }
        if (element.featureName == RoleManagement.Reports) { this.Reports = element }
        if (element.featureName == RoleManagement.Tests) { this.Tests = element }
        if (element.featureName == RoleManagement.Examinees) { this.Examinees = element }
        if (element.featureName == RoleManagement.Tags) { this.Tags = element }
        if (element.featureName == RoleManagement.Users) { this.Users = element }
        if (element.featureName === RoleManagement.Collections) { this.collectionFlag = element }
        if (element.featureName === RoleManagement.Roles) { this.rolesFlag = element }
        if (element.featureName === RoleManagement.Home) { this.Home = element }
        if (element.featureName === RoleManagement.Assessments) { this.Assessments = element }
      });
    }, (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  navigationRefresh(): void {
    sessionStorage.setItem('viewReport', 'false')
    this.AssessmentSer.patientDataFromAssessment.next(false);
  }

  loadCollections(): void {
    const currentCollectionuuId = JSON.parse(sessionStorage?.getItem('defaultcollectionuuid'));
    this.collectionID = JSON.parse(sessionStorage?.getItem('defaultcollectionid'));
    this.collectionData$ = this.collectionService.getCollection()?.subscribe((collectionData: any) => {
      this.collectionData = collectionData?.data;
      // Dropdown Search filter
      this.searchOptions = this.collectionData;
      this.selected = this.searchOptions[0];
      this.filteredList = this.searchOptions.slice();
      if (currentCollectionuuId) {
        this.selectedCollection = this.filteredList?.filter(x => x?.collectionuuId == currentCollectionuuId)[0];
        this.selectedCollection = this.selectedCollection?.collectionName;
      }

      this.selectedCollectionName = this.collectionData[0].collectionName;
      if (sessionStorage.getItem('defaultcollectionuuid')) {
        let data = JSON.parse(sessionStorage.getItem('defaultcollectionuuid') || '{}');
        this.collectionuuIdToNavigate = data;
        this.tagUrl = this.tagUrl + this.collectionIdToNavigate + '/tags';
        this.selectedCollectionName = this.collectionData.find((d) => d['collectionuuId'] === data)?.collectionName;
      }
      else {
        this.selectedCollectionName = this.collectionData[0].collectionName;
        this.collectionuuIdToNavigate = this.collectionData[0].collectionuuId;
        this.tagUrl = this.tagUrl + this.collectionuuIdToNavigate + '/tags';
      }
    }, (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }
  navHide() {

  }
  schedule() {
    this.router.navigate(['/collections/' + this.collectionuuIdToNavigate + '/schedules']);
  }

  navDashboard(): void {
    this.router.navigate(['/collections/' + this.collectionuuIdToNavigate + '/dashboard']);
  }

  navItems(): void {
    this.router.navigate(['/collections/' + this.collectionuuIdToNavigate + '/items']);
  }

  navTestLanding(): void {
    this.router.navigate(['/collections/' + this.collectionuuIdToNavigate + '/test']);
  }
  navTags(): void {

    this.router.navigate(["/collections/" + this.collectionuuIdToNavigate + "/tags"]);
  }

  navUsers() {
    this.router.navigate(['/users']);
  }
  navExamineee() {
    this.router.navigate(['/examinees']);
  }
  navExamineeGroup() {
    this.router.navigate(['/examinee-group']);
  }
  navReports(): void {
    this.reportService.routeToReportObs.next(false);
    this.router.navigate(["/collections/" + this.collectionuuIdToNavigate + '/reports'])
  }
  LogOut() {
    const UserData = JSON.parse(sessionStorage.getItem("currentUser"))
    if(this.ExpireTokenSubscription){this.ExpireTokenSubscription.unsubscribe();}
    this.ExpireTokenSubscription = this.collectionService.expireToken(UserData.useruuid, UserData.loginUuid).subscribe(res=>{
      let msg = res.message
      if(msg === "Logged out successfully"){
        sessionStorage.clear();
        localStorage.removeItem('rememberMe')
        this.appService.changeUserHeader(0);
        this.idleService.removeIdleFormLocalStorage();
        this.router.navigate(['/login']);
      };
    },(error)=>{
      this.webErrorService.handleAPIErrors(error);
    });
  }

  changePassword() {
    this.router.navigate(["/change-password"]);
  }

  editCollection(selectedCollection: any) {
    if (selectedCollection) {
      this.selectedCollectionName = selectedCollection?.collectionName;
      this.collectionIdToNavigate = selectedCollection?.collectionid;
      this.collectionID = selectedCollection?.collectionid;
      this.collectionuuIdToNavigate = selectedCollection?.collectionuuId;
      this.shareDataService.setGlobalCollectionuuId(selectedCollection?.collectionuuId);
      this.shareDataService.setGlobalCollectionId(selectedCollection?.collectionid);
      this.getUserRole(this.collectionID);
      this.roleSer.getUserRole(+selectedCollection?.collectionid).subscribe(data => {
        this.roleSer.userRoles = data.data.userrole;
        this.assignedRole = this.roleSer.userRoles[0].rolesAssigned;
        this.roleSer.navigateToDefaultPage();
      }, (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
    }

  }

  addCollection(): void {
    this.shareDataService.addCollection();

    this.router.navigate(['collections/add-collection']);
  }

  viewAllCollection(): void {
    if (this.collectionFlag && this.collectionFlag['viewAllowed']) {
      this.router.navigate(['/collections']);
    }
  }

  // Process idle timer
  processIdle(): void {
    if (this.userService.isAuthenticated()) {
      this.idleService.initializeSessionTimeout();
      this.idleService.idleUserChecker.subscribe((status: string) => {
        if (status === 'TIMER_COMPLETE') {
          this.idleService.idleLogOut();
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.collectionData$) {
      this.collectionData$?.unsubscribe();
    }
    if (this.languageSubsc) {
      this.languageSubsc.unsubscribe();
    }
    if(this.ExpireTokenSubscription){this.ExpireTokenSubscription.unsubscribe();}
  }

}
